<div class="layout-column tr fade-element-in-only"
     (click)="viewTasksEvent.emit({ agent: {id: agentProgress.agentId,
                  agentType: agentProgress.agentType,
                   tags: agentProgress.tags ,
                   skills: agentProgress.skills,
                   user: agentProgress.user,
                    lastKnownLocation: agentProgress.lastKnownLocation} , tasks: agentProgress.tasks })">

  <div class="flex layout-row layout-align-start-center">

    <div class="flex td xxxsmall layout-row layout-align-start-center">
      <div class="color-container"
           [ngStyle]="{'background': agentProgress.displayColor}">
      </div>

      <div ngbDropdown container="body">
        <bringoz-button type="tertiary"
                        id="dropdownBasic1"
                        (click)="$event.stopPropagation();"
                        ngbDropdownToggle>
          <bringoz-icon iconName="menu"></bringoz-icon>
        </bringoz-button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">

          <button ngbDropdownItem
                  [disabled]="agentProgress.lastKnownLocation.deviceReference && agentProgress.lastKnownLocation.deviceReference.gpsStatus"
                  (click)="askToEnableGpsEvent.emit({ agentPnType: 'GpsStatusUpdate', agentId: agentProgress.agentId})"
                  type="tertiary">
            <div class="layout-row layout-align-start-center">
              <bringoz-icon iconName="gps" [classSize]="'xl'"></bringoz-icon>
              <span class="br-body-2 margin-left-10" translate>Ask to enable GPS</span>
            </div>
          </button>

          <button ngbDropdownItem
                  [disabled]="agentProgress.lastKnownLocation.deviceReference && agentProgress.lastKnownLocation.deviceReference.gpsPermission &&
             agentProgress.lastKnownLocation.deviceReference.gpsPermission === gpsPermissionType.All"
                  (click)="askToEnableGpsPermissionsEvent.emit({ agentPnType: 'GpsPermissionUpdate', agentId: agentProgress.agentId})"
                  type="tertiary">
            <div class="layout-row layout-align-start-center">
              <bringoz-icon iconName="gps" [classSize]="'xl'"></bringoz-icon>
              <span class="br-body-2 margin-left-10" translate>Ask to enable GPS permissions</span>
            </div>
          </button>

          <button ngbDropdownItem
                  [disabled]="agentProgress.agentStatus === agentStatusType.OnDuty || agentProgress.agentStatus === agentStatusType.OnDutyOnBreak "
                  (click)="askToClockIn.emit({ agentPnType: 'ClockInUpdate', agentId: agentProgress.agentId})"
                  type="tertiary">
            <div class="layout-row layout-align-start-center">
              <bringoz-icon iconName="status" [classSize]="'xl'"></bringoz-icon>
              <span class="br-body-2 margin-left-10" translate>Ask to clock-in</span>
            </div>
          </button>

          <button *ngIf="agentProgress.agentType !== agentType.Robot"
                  ngbDropdownItem
                  (click)="swapServicesEvent.emit(
                  {id: agentProgress.agentId,
                  agentType: agentProgress.agentType,
                   tags: agentProgress.tags ,
                   skills: agentProgress.skills,
                   user: agentProgress.user,
                    lastKnownLocation: agentProgress.lastKnownLocation})"
                  type="tertiary">
            <div class="layout-row layout-align-start-center">
              <bringoz-icon iconName="swap" [classSize]="'xl'"></bringoz-icon>
              <span class="br-body-2 margin-left-10" translate>Swap Tasks</span>
            </div>
          </button>

          <button ngbDropdownItem
                  (click)="viewAgentItineraryEvent.emit()"
                  type="tertiary">
            <div class="layout-row layout-align-start-center">
              <bringoz-icon iconName="task" [classSize]="'xl'"></bringoz-icon>
              <span class="br-body-2 margin-left-10" translate>View Agent Itinerary</span>
            </div>
          </button>

        </div>
      </div>
    </div>

    <!--Agent Name-->
    <div *ngIf="enabledColumnsMap.agentName?.enabled" class="flex td large layout-row layout-align-start-center">

      <app-user-avatar [user]="agentProgress.user"
                       [url]="agentProgress.user.avatarUrl"
                       [color]="agentProgress.displayColor"
                       size="xsmall"
                       class="margin-right-5">

      </app-user-avatar>

      <div class="flex layout-column">

        <div class="layout-row layout-align-start-center">
          <span class="br-link-1 text-ellipsis"
                [ngbTooltip]="agentProgress.agentName"
                openDelay="300" triggers="hover" container="body">{{ agentProgress.agentName }}</span>

          <bringoz-icon class="margin-left-5"
                        *ngIf="agentProgress.branchReferences?.length"
                        iconName="branch" fill="#7E7E7E" classSize="md"
                        [ngbTooltip]="tooltipTmpl"
                        openDelay="300" triggers="hover" container="body"></bringoz-icon>
          <ng-template #tooltipTmpl>
            <div class="layout-column">
              <span *ngFor="let branch of agentProgress.branchReferences">
                {{ branch.name }}
              </span>
            </div>
          </ng-template>


          <app-agent-location
            *ngIf="enabledColumnsMap.lastKnownLocation?.enabled && agentProgress.lastKnownLocation.deviceReference"
            [location]="agentProgress.lastKnownLocation.coordinates"
            direction="right"
            [showText]="false"
            [locationTrackingApproval]="agentProgress?.locationTrackingApproval"
            [gpsStatus]="agentProgress.lastKnownLocation.deviceReference?.gpsStatus"
            [gpsPermission]="agentProgress.lastKnownLocation.deviceReference?.gpsPermission"
            [lastUpdate]="agentProgress.lastKnownLocation.updatedAt">
          </app-agent-location>
        </div>

        <div class="layout-row layout-align-start-center">
          <app-bringoz-tags *ngIf="agentProgress.tags"
                            [tags]="agentProgress.tags"
                            [tagType]="tagTypes.Agent"
                            [isShowTagDescriptions]="true"
                            backgroundColor="transparent"
                            color="#7E7E7E"
                            maxTags="1">
          </app-bringoz-tags>

          <span *ngIf="agentProgress.externalId"
                class="br-body-1 text-ellipsis font-weight-400 gray-102 margin-left-5">{{ agentProgress.externalId }}</span>

          <div *ngIf="!!currentTask && currentTask.resourceName"
               class="margin-left-5 layout-row layout-align-start-center">
            <bringoz-icon iconName="resources" fill="#7E7E7E" classSize="md" class="margin-right-5"></bringoz-icon>
            <span class="br-body-1 text-ellipsis font-weight-400 gray-102"
                  [ngbTooltip]="currentTask.resourceName"
                  openDelay="300" triggers="hover" container="body">{{ currentTask.resourceName }}</span>
          </div>
        </div>

      </div>

    </div>

    <!--Agent Status-->
    <div *ngIf="enabledColumnsMap.agentStatus?.enabled" class="flex td xsmall layout-column">
      <!--      <app-user-avatar ></app-user-avatar>-->
      <span class="br-body-1 agent-status layout-row layout-align-start-center"
            [ngbTooltip]="agentStatusUpdatedAtTooltip"
            openDelay="300" triggers="hover" container="body"
            [ngClass]="agentProgress.agentStatus">{{ agentProgress.agentStatus | translate }}</span>

      <ng-template #agentStatusUpdatedAtTooltip>
           <span class="br-body-2 font-weight-400">
          {{ {statusUpdatedAt: agentProgress.statusUpdatedAt} | bringozFullDate: 'statusUpdatedAt' }} {{ 'at' | translate }} {{ {statusUpdatedAt: agentProgress.statusUpdatedAt} | bringozTime: 'statusUpdatedAt' }}
        </span>
      </ng-template>
    </div>

    <!--Agent Skills-->
    <div *ngIf="enabledColumnsMap.tags?.enabled" class="flex td medium layout-column">
      <div class="layout-row layout-align-start-center">
        <div *ngIf="!!agentProgress.skills?.length" class="layout-row">
          <app-skill-tags [skillsIds]="agentProgress.skills" [limit]="2"></app-skill-tags>
        </div>
        <span class="margin-left-5 br-body-1 font-weight-400 text-ellipsis"
              [ngbTooltip]="'AGENT_TYPES.' + agentProgress.agentType | translate"
              openDelay="300" triggers="hover"
              container="body">{{ 'AGENT_TYPES.' + agentProgress.agentType | translate }}</span>
      </div>
    </div>

    <!--Completed/Total agent Tasks-->
    <div *ngIf="enabledColumnsMap.totalDropoffs?.enabled || enabledColumnsMap.completedDropoffs?.enabled"
         class="flex td xxsmall layout-row">
      <span class="br-body-1" *ngIf="enabledColumnsMap.completedDropoffs?.enabled"
            [ngClass]="{'green-102': agentProgress.completedTasks > 0 }">{{ agentProgress.completedTasks }}</span>
      <span class="br-body-1"
            *ngIf="enabledColumnsMap.completedDropoffs?.enabled && enabledColumnsMap.totalDropoffs?.enabled">/</span>
      <span class="br-body-1" *ngIf="enabledColumnsMap.totalDropoffs?.enabled">{{ agentProgress.totalTasks }}</span>
    </div>

    <!--Geo Events Estimated Completed Tasks-->
    <div *ngIf="enabledColumnsMap.completedTasksEstimationFromGeoEvents?.enabled"
         class="flex td small layout-row">
      <span class="br-body-1">{{ agentProgress.completedTasksEstimationFromGeoEvents }}</span>
      <span class="br-body-1" *ngIf="enabledColumnsMap.totalDropoffs?.enabled">/</span>
      <span class="br-body-1" *ngIf="enabledColumnsMap.totalDropoffs?.enabled">{{ agentProgress.totalTasks }}</span>
    </div>

    <!--Late Tasks-->
    <div *ngIf="enabledColumnsMap.numberOfLateDropoffs?.enabled" class="br-body-1 flex td xsmall layout-column"
         [ngClass]="{'red-101': agentProgress.numberOfLateTasks > 0}">
      {{ agentProgress.numberOfLateTasks }}
    </div>

    <!--Current Task Status-->
    <div *ngIf="enabledColumnsMap.currentTaskStatus?.enabled" class="flex td large layout-column">
      <ng-container *ngIf="!!currentTask">
        <div class="layout-row layout-align-start-center">

          <span class="br-body-1 current-task-status margin-right-5"
                [ngClass]="currentTask.status">{{ 'STATUS_TAG.' + currentTask.status | translate }}</span>

          <bringoz-icon *ngIf="currentTask.taskSpec.locationDetails.locationType === locationTypes.ACCOUNT"
                        iconName="account" [fill]="this.currentTaskPurposeColor" class="margin-right-5"></bringoz-icon>

          <bringoz-icon *ngIf="currentTask.taskSpec.locationDetails.locationType === locationTypes.DEPOT"
                        iconName="depot" [fill]="this.currentTaskPurposeColor" class="margin-right-5"></bringoz-icon>

          <bringoz-icon *ngIf="currentTask.taskSpec.locationDetails.locationType === locationTypes.CUSTOMER"
                        iconName="customer-outline" [fill]="this.currentTaskPurposeColor"
                        class="margin-right-5"></bringoz-icon>

          <bringoz-icon *ngIf="currentTask.taskSpec.locationDetails.locationType === locationTypes.CUSTOM"
                        iconName="location-pin-plus-outline" [fill]="this.currentTaskPurposeColor"
                        class="margin-right-5"></bringoz-icon>

          <app-demand-account-link *ngIf="currentTask.taskSpec.locationDetails.locationType === locationTypes.ACCOUNT"
                                   class="text-ellipsis"
                                   [address]="currentTask.taskSpec.address"
                                   [account]="{id: currentTask.taskSpec.locationDetails.id, name: currentTask.taskSpec.contact.fullName}">
          </app-demand-account-link>

          <app-depot-link *ngIf="currentTask.taskSpec.locationDetails.locationType === locationTypes.DEPOT"
                          class="text-ellipsis"
                          [address]="currentTask.taskSpec.address"
                          [depot]="currentTask.taskSpec.depotReference"></app-depot-link>

          <app-customer-link *ngIf="currentTask.taskSpec.locationDetails.locationType === locationTypes.CUSTOMER"
                             [address]="currentTask.taskSpec.address"
                             [customer]="{customerId: currentTask.taskSpec.locationDetails.id, name: currentTask.taskSpec.contact.fullName || currentTask.taskSpec.contact.businessName}">

          </app-customer-link>

          <span *ngIf="currentTask.taskSpec.locationDetails.locationType === locationTypes.CUSTOM || (
                  currentTask.taskSpec.contact && currentTask.taskSpec.locationDetails.locationType !== locationTypes.ACCOUNT &&
                 currentTask.taskSpec.locationDetails.locationType !== locationTypes.DEPOT &&
                     currentTask.taskSpec.locationDetails.locationType !== locationTypes.CUSTOMER)"
                class="br-body-1 primary-100 margin-right-10 text-ellipsis"
                [ngbTooltip]="currentTask.taskSpec.contact.fullName"
                openDelay="300" triggers="hover" container="body">{{ currentTask.taskSpec.contact.fullName }}</span>


          <bringoz-button type="tertiary"
                          (onClick)="onViewServiceDrillDown(currentTask, $event);$event.stopPropagation();">
            <bringoz-icon iconName="open" fill="#266AFF"></bringoz-icon>
          </bringoz-button>

        </div>
      </ng-container>
    </div>

    <!--Current Task Geo Events Status-->
    <div *ngIf="enabledColumnsMap.currentTaskIdFromGeoEvents?.enabled" class="flex td large layout-column">
      <ng-container *ngIf="!!currentTaskFromGeoEvents">
        <div class="layout-row layout-align-start-center">

          <span class="br-body-1 current-task-status margin-right-55"
                [ngClass]="currentTaskFromGeoEvents.statusByGeoEvents">{{ 'STATUS_TAG.' + currentTaskFromGeoEvents.statusByGeoEvents | translate }}</span>


          <bringoz-icon *ngIf="currentTaskFromGeoEvents.taskSpec.locationDetails.locationType === locationTypes.ACCOUNT"
                        iconName="account" [fill]="this.currentTaskFromGeoEventPurposeColor"
                        class="margin-right-5"></bringoz-icon>

          <bringoz-icon *ngIf="currentTaskFromGeoEvents.taskSpec.locationDetails.locationType === locationTypes.DEPOT"
                        iconName="depot" [fill]="this.currentTaskFromGeoEventPurposeColor"
                        class="margin-right-5"></bringoz-icon>

          <bringoz-icon
            *ngIf="currentTaskFromGeoEvents.taskSpec.locationDetails.locationType === locationTypes.CUSTOMER"
            iconName="customer-outline" [fill]="this.currentTaskFromGeoEventPurposeColor"
            class="margin-right-5"></bringoz-icon>

          <bringoz-icon *ngIf="currentTaskFromGeoEvents.taskSpec.locationDetails.locationType === locationTypes.CUSTOM"
                        iconName="location-pin-plus-outline" [fill]="this.currentTaskFromGeoEventPurposeColor"
                        class="margin-right-5"></bringoz-icon>

          <app-demand-account-link
            *ngIf="currentTaskFromGeoEvents.taskSpec.locationDetails.locationType === locationTypes.ACCOUNT"
            class="text-ellipsis"
            [address]="currentTaskFromGeoEvents.taskSpec.address"
            [account]="{id: currentTaskFromGeoEvents.taskSpec.locationDetails.id, name: currentTaskFromGeoEvents.taskSpec.contact.fullName}">
          </app-demand-account-link>


          <app-depot-link *ngIf="currentTaskFromGeoEvents.taskSpec.locationDetails.locationType === locationTypes.DEPOT"
                          class="text-ellipsis"
                          [address]="currentTaskFromGeoEvents.taskSpec.address"
                          [depot]="currentTaskFromGeoEvents.taskSpec.depotReference"></app-depot-link>


          <app-customer-link
            *ngIf="currentTaskFromGeoEvents.taskSpec.locationDetails.locationType === locationTypes.CUSTOMER"
            [address]="currentTaskFromGeoEvents.taskSpec.address"
            [customer]="{customerId: currentTaskFromGeoEvents.taskSpec.locationDetails.id, name: currentTaskFromGeoEvents.taskSpec.contact.fullName || currentTaskFromGeoEvents.taskSpec.contact.businessName}">

          </app-customer-link>


          <span *ngIf="currentTaskFromGeoEvents.taskSpec.locationDetails.locationType === locationTypes.CUSTOM || (
                  currentTaskFromGeoEvents.taskSpec.contact && currentTaskFromGeoEvents.taskSpec.locationDetails.locationType !== locationTypes.ACCOUNT &&
                 currentTaskFromGeoEvents.taskSpec.locationDetails.locationType !== locationTypes.DEPOT &&
                     currentTaskFromGeoEvents.taskSpec.locationDetails.locationType !== locationTypes.CUSTOMER)"
                class="br-body-1 primary-100 margin-right-10 text-ellipsis"
                [ngbTooltip]="currentTaskFromGeoEvents.taskSpec.contact.fullName"
                openDelay="300" triggers="hover"
                container="body">{{ currentTaskFromGeoEvents.taskSpec.contact.fullName }}</span>

          <bringoz-button type="tertiary"
                          (onClick)="onViewServiceDrillDown(currentTaskFromGeoEvents, $event);$event.stopPropagation();">
            <bringoz-icon iconName="open" fill="#266AFF"></bringoz-icon>
          </bringoz-button>

        </div>
      </ng-container>
    </div>

    <!--Current Task Geo Events Status-->
    <div *ngIf="enabledColumnsMap.currentTaskStartTimeEstimation?.enabled"
         class="br-body-1 flex td large layout-column">
      <ng-container *ngIf="!!currentTaskFromGeoEvents">
        <span [ngbTooltip]="'geo-event estimation value' | translate" openDelay="300"
              triggers="hover"
              container="body">{{ currentTaskFromGeoEventsServiceTime | bringozTimeConvert:true:false }}</span>
        <span>/</span>
        <span [ngbTooltip]="'planned value' | translate" openDelay="300"
              triggers="hover"
              container="body">{{ currentTaskFromGeoEvents.analysis.serviceTime | bringozTimeConvert:true:false }}</span>
      </ng-container>
    </div>

    <!--Packages-->
    <div *ngIf="enabledColumnsMap.taskPackageList?.enabled"
         class="flex td small layout-row layout-align-start-center"
         [ngbTooltip]="currentTask && !!currentTask.taskPackageList?.length && currentTask.taskPackageList[0].items?.length > 1 ? tooltipTmpl : null"
         openDelay="300"
         triggers="hover"
         container="body">
      <ng-container
        *ngIf="currentTask && !!currentTask.taskPackageList?.length && !!currentTask.taskPackageList[0].items?.length">
        <app-bringoz-package-item [id]="currentTask.taskPackageList[0].items[0].size">

        </app-bringoz-package-item>
        <span *ngIf="currentTask.taskSpec.purpose !== 'Operation'"
              class="br-body-1 margin-left-5 font-weight-500">X{{ currentTask.taskPackageList[0].items[0].count || 0 }}</span>

        <span *ngIf="currentTask.taskPackageList[0].items.length > 1"
              class="margin-left-5">+{{ currentTask.taskPackageList[0].items.length - 1 }}</span>
      </ng-container>

      <ng-template #tooltipTmpl>
        <div *ngIf="currentTask && !!currentTask.taskPackageList?.length" class="layout-column">
          <div *ngFor="let item of currentTask.taskPackageList[0].items; let first = first"
               class="layout-row layout-align-start-center">
            <ng-container *ngIf="!first">
              <app-bringoz-package-item [id]="item.size">

              </app-bringoz-package-item>
              <span *ngIf="currentTask.taskSpec.purpose !== 'Operation'"
                    class="br-body-1 margin-left-5 font-weight-500">X{{ item.count || 0 }}</span>
            </ng-container>
          </div>
        </div>
      </ng-template>

    </div>

  </div>


</div>

